<template>
  <div class="page">
    <div class="page_contents">
      <div class="contents_div">
        <div class="page_header">공지사항</div>
        <div class="detail_div">
          <div class="notice_header_div">
            <div class="notice_title">{{ noticeData.제목 }}</div>
            <div class="notice_date">{{ noticeData.게시시작일 }}</div>
            <div class="notice_hits">조회 {{ noticeData.조회수 }}</div>
          </div>
          <div class="notice_contents" v-html="noticeData.내용"></div>
          <div class="notice_file_list">
            <div class="notice_file_div" v-if="noticeData.첨부파일명1 != null">
              <img src="@/assets/images/file_icon.png" />
              <div class="notice_file_link" @click="getFile(noticeData.공지순번, 1, noticeData.첨부파일명1)">{{ noticeData.첨부파일명1 }}</div>
            </div>
            <div class="notice_file_div" v-if="noticeData.첨부파일명2 != null">
              <img src="@/assets/images/file_icon.png" />
              <div class="notice_file_link" @click="getFile(noticeData.공지순번, 2, noticeData.첨부파일명2)">{{ noticeData.첨부파일명2 }}</div>
            </div>
            <div class="notice_file_div" v-if="noticeData.첨부파일명3 != null">
              <img src="@/assets/images/file_icon.png" />
              <div class="notice_file_link" @click="getFile(noticeData.공지순번, 2, noticeData.첨부파일명3)">{{ noticeData.첨부파일명3 }}</div>
            </div>
          </div>
          <div class="notice_btn_div"><div class="back_btn" @click="goPage()">목록으로</div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import noticeAPI from "../api/noticeAPI";
import { useRouter } from "vue-router";
import { Notice, ApiResponse, Member } from "../common/types";
import { convertDate } from "../utils/utils";
const router = useRouter();
const noticeData = ref<Notice>({
  공지순번: 0,
  제목: "",
  조회수: 0,
  내용: "",
  노출여부: "",
  작성자: {} as Member,
  첨부파일처리1: "",
  첨부파일명1: null,
  첨부파일처리2: "",
  첨부파일명2: null,
  첨부파일처리3: "",
  첨부파일명3: null,
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  게시시작일: "",
});
onMounted(() => {
  console.log(router.currentRoute.value);
  getDetail();
});
const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  console.log(seq);
  noticeAPI.noticeDetail(seq).then((res) => {
    noticeData.value = res.data.data;
  });
};
const getFile = (공지순번: number, idx: number, 파일명: string) => {
  noticeAPI.downloadNoticeboardFile(공지순번, idx, 파일명);
};

// downloadNoticeboardFile(seq: number, index: number, filename: string) {
//         return axiosInstance.get(`/api/anonymous/noticeboards/${seq}/files/${index}`, {
//             responseType: 'blob'
//         }).then((response: any) => {
//             const url = window.URL.createObjectURL(new Blob([response]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', filename); // You can set the file name here
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         });
//     }

const goPage = () => {
  router.go(-1);
};
</script>
<style scoped>
.page_header {
  padding: 40px 0px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 38px;
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 51px;
  justify-content: center;
}
.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 100px;
  align-items: center;
}
.contents_div {
  width: 1010px;
}
.detail_div {
  border-top: 3px solid #041e42;
}
.notice_header_div {
  height: 87px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  /* gap: 50px; */
}
.notice_title {
  width: 100%;
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #272727;
}
.notice_date {
  color: #9b9b9b;
  font-size: 16px;
  min-width: 91px;
  text-align: right;
}
.notice_hits {
  color: #9b9b9b;
  font-size: 16px;
  min-width: 110px;
  text-align: right;
}
.notice_contents {
  padding: 30px 0px;
  min-height: 150px;
}
.notice_file_list {
  display: flex;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.notice_file_div {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}
.notice_file_link {
  font-size: 16px;
  color: #0078db;
  cursor: pointer;
  border-bottom: 1px solid #0078db;
}
.notice_btn_div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.back_btn {
  border: 1px solid #bcbcbc;
  width: 247px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  color: #272727;
  cursor: pointer;
}
</style>
